import calcVerticalHeight from '../../utils/calcVerticalHeight'

export const ERA5_DOWNLOAD_QUERYKEY = 'era5Download'

export const MAP_STYLE = {
  width: '100%',
  height: calcVerticalHeight({ customOffset: 12 }),
}

export const RECTANGLE_OPTIONS = {
  fillColor: 'red',
  fillOpacity: 0.2,
  strokeColor: 'red',
  strokeOpacity: 1,
  strokeWeight: 2,
}

export const AREA_REGEX = /^-?\d+(\.\d+)?\/-?\d+(\.\d+)?\/-?\d+(\.\d+)?\/-?\d+(\.\d+)?$/

export const INICIAL_VALUES = {
  tsIn: new Date(new Date().getFullYear(), new Date().getMonth() - 3),
  tsFin: new Date(new Date().getFullYear(), new Date().getMonth() - 1),
  area: '',
  center: { lat: -12.75, lng: -42.0 },
}
